import ComingSoonEmptyState from 'src/components/emptyStateMessage/ComingSoonEmptyState'

const ComparisonRoute = () => (
  <ComingSoonEmptyState />
)

export default ComparisonRoute
